const Card = ({ title, content, icon: Icon, buttonText, onButtonClick, url }) => (
  <div className="card-minimal p-6 flex flex-col gap-4 group hover:-translate-y-0.5 transition-transform duration-300">
    {Icon && (
      <div className="w-10 h-10 rounded-xl bg-brand-50 flex items-center justify-center text-brand-800 group-hover:bg-brand-800 group-hover:text-white transition-all duration-200 text-2xl">
        <Icon />
      </div>
    )}
    <div className="flex-1">
      <h3 className="font-semibold text-stone-950 mb-1.5">{title}</h3>
      <p className="text-sm text-stone-500 leading-relaxed">{content}</p>
    </div>
    {!url && buttonText && (
      <button onClick={onButtonClick} className="btn-ghost-sm self-start">
        {buttonText}
      </button>
    )}
    {url && buttonText && (
      <a href={url} target="_blank" rel="noopener noreferrer" className="btn-ghost-sm self-start">
        {buttonText}
      </a>
    )}
  </div>
);

export default Card;
